import { render, staticRenderFns } from "./GlSwitch.vue?vue&type=template&id=9487df56&"
import script from "./GlSwitch.vue?vue&type=script&lang=js&"
export * from "./GlSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports